import { Check } from "lucide-react";

export const STATUSES = ["Ordered", "Label Printed", "Received", "In Testing", "Results Ready"];

const STYLES = {
  "Ordered": "bg-slate-100 text-slate-600",
  "Label Printed": "bg-sky-100 text-sky-700",
  "Received": "bg-indigo-100 text-indigo-700",
  "In Testing": "bg-amber-100 text-amber-700",
  "Results Ready": "bg-emerald-100 text-emerald-700",
  "pending_payment": "bg-slate-100 text-slate-500",
};

export function StatusBadge({ status }) {
  return (
    <span className={`inline-flex items-center rounded-full px-3 py-1 text-xs font-semibold ${STYLES[status] || "bg-slate-100 text-slate-600"}`} data-testid="status-badge">
      {status === "pending_payment" ? "Pending Payment" : status}
    </span>
  );
}

export function StatusTracker({ status }) {
  const current = STATUSES.indexOf(status);
  return (
    <div className="flex items-center" data-testid="status-tracker">
      {STATUSES.map((s, i) => {
        const done = i <= current;
        return (
          <div key={s} className="flex flex-1 items-center last:flex-none">
            <div className="flex flex-col items-center">
              <span className={`grid h-9 w-9 place-items-center rounded-full text-xs font-bold ${done ? "bg-teal text-white" : "bg-slate-100 text-slate-400"}`}>
                {done ? <Check className="h-4 w-4" /> : i + 1}
              </span>
              <span className={`mt-2 w-20 text-center text-[11px] font-medium leading-tight ${done ? "text-ocean" : "text-slate-400"}`}>{s}</span>
            </div>
            {i < STATUSES.length - 1 && <div className={`mx-1 h-0.5 flex-1 ${i < current ? "bg-teal" : "bg-slate-200"}`} />}
          </div>
        );
      })}
    </div>
  );
}
